import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InteractiveMapComponent } from '@app/components/_shared/interactive-map/interactive-map.component';
import { Breadcrumb } from '@app/models/_base/breadcrumb.model';
import { CourseFilter } from '@app/models/courses/filter.model';
import { FilterOption } from '@app/models/courses/filterOption.model';
import {
  PrimaryCourseFilterRequest,
  PrimaryCourseFiltersRequest
} from '@app/models/courses/filterRequest.primary.model';
import { CourseService } from '@app/services/course.service';
import { Footer } from '@app/services/footer.service';
import { LocalisationService } from '@app/services/localisation.service';
import { RouteBreadcrumbs } from '@app/services/routeBreadcrumbs.service';
import * as _ from 'lodash';

import { CourseAreaApplyFiltersComponent } from './../../../../components/course-areas/filters/course-area-apply-filters/course-area-apply-filters.component';
import { KeyValuePair } from '@app/models/_shared/keyValue';

@Component({
  selector: 'app-course-area-location-filter',
  templateUrl: './course-area-location-filter.component.html',
  styleUrls: ['./course-area-location-filter.component.scss']
})
export class CourseAreaLocationFilterComponent implements OnInit {
  @ViewChild(InteractiveMapComponent)
  child;

  public static route: string = CourseAreaApplyFiltersComponent.route + '/location-filter';
  public static footerPath: string = CourseAreaApplyFiltersComponent.route;

  locale: any = {};

  locationCourseFilter: CourseFilter = new CourseFilter();
  private footerTitle: string;
  filterText: string = '';

  changedInfo: boolean = false;

  constructor(
    private routeBreadcrumbs: RouteBreadcrumbs,
    private footerService: Footer,
    private courseService: CourseService,
    private router: Router,
    private localisation: LocalisationService
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent(
      'CourseAreaLocationFilterComponent'
    );

    this.footerTitle = this.locale.footerText;

    let parentLocale = this.localisation.getTranslationsForComponent(
      'CourseAreaApplyFiltersComponent'
    ) as any;

    this.routeBreadcrumbs.breadcrumbs.next([
      new Breadcrumb(parentLocale.breadcrumbText, CourseAreaApplyFiltersComponent.route),
      new Breadcrumb(this.locale.breadcrumbText, null)
    ]);

    this.footerService.update({
      title: this.footerTitle,
      action: () => this.submitLocation(this)
    });

    this.getPrimaryCourseFilters(null);
  }

  submitLocation(scope: this): void {
    if (this.changedInfo == true) {
      /*
      * Now Reset any settings prior
      */
      this.courseService.updateCategorySelected(2); // reset the category return to default
      this.courseService.deleteSecondaryFilters().subscribe(filters => {}); // reset secondary filters
      this.changedInfo = false;
    }
    scope.locationCourseFilter.completed = false;
    this.isComplete(scope.locationCourseFilter.options, scope);

    scope.courseService
      .savePrimaryCourseFilter(new PrimaryCourseFilterRequest(scope.locationCourseFilter))
      .subscribe(filters => {
        scope.router.navigate(['/centigrade/course-area-filters']);
      });
  }

  reset() {
    this.courseService
      .deletePrimaryCourseFilter(this.locationCourseFilter.id)
      .subscribe(filters => {
        this.router.navigate(['/centigrade/course-area-filters']);
      });
  }

  isComplete(options: FilterOption[], scope: this): void {
    _.forEach(options, opt => {
      if (opt.selected) {
        scope.locationCourseFilter.completed = true;
      } else {
        this.isComplete(opt.options, scope);
      }
    });
  }

  search(text: string) {
    this.locationCourseFilter.options.forEach(option => {
      this.closeAll(option);
    });
    if (text.length > 2) {
      this.locationCourseFilter.options.forEach(option => {
        this.filterOption(option, text);
      });
    }
  }

  filterOption(option: FilterOption, text: string): boolean {
    let match = false;

    match = option.values.some(e => e.value.toUpperCase().indexOf(text.toUpperCase()) !== -1);

    if (!!option.options) {
      option.options.forEach(e => {
        if (this.filterOption(e, text)) {
          match = true;
        }
      });
    }

    option.shown = match;
    option.expanded = match;

    return match;
  }

  closeAll(option: FilterOption) {
    option.expanded = false;
    option.shown = true;
    if (option.options != null) {
      option.options.forEach(o => {
        this.closeAll(o);
      });
    }
  }

  getPrimaryCourseFilters(filters: PrimaryCourseFiltersRequest) {
    this.courseService.getPrimaryCourseFilters(filters).subscribe(filters => {
      //Populate join course filter toggle area.
      let filterId = filters.filters.find(filter => filter.tag === 'FTYPE_LOCATION').id;

      this.courseService.getPrimaryCourseFilterDetails(filterId).subscribe(filter => {
        this.locationCourseFilter = filter.filter;
        this.locationCourseFilter.options.forEach(o => {
          this.closeAll(o);
        });
      });
    });
  }

  selectLocation(option: FilterOption, childValue?: boolean) {
    this.changedInfo = true;
    option.selected = childValue == undefined ? !option.selected : childValue.valueOf();
    _.forEach(option.options, (opt, key) => {
      this.selectLocation(opt, option.selected);
    });

    if (childValue === undefined) {
      let parents = option.id.toString().split('-');
      parents.pop();
      if (parents[0]) {
        let updateFilter = this.locationCourseFilter.options.find(
          option => option.id == parents[0]
        );
        updateFilter.selected = false;
        if (parents[1]) {
          let furtherFilter = updateFilter.options.find(
            option => option.id == parents[0] + '-' + parents[1]
          );
          furtherFilter.selected = false;
        }
      }
    }
  }

  filterNonEmptyRegions(values: KeyValuePair<string, any>[]) {
    return values.filter(({ value }) => !!value);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/course-areas/filters/course-area-location-filter/course-area-location-filter.component.ts